<template>
    <div>
        <div class="card-header">
            <div class="row align-items-center">
                <div class="col-7">
                    <h4 class="card-title">Noti SMS Payment Received</h4>
                </div>
                <div class="col-4 text-right"><button type="button" class="btn btn-success" @click="saveSetting" :disabled="isLoading">SAVE</button></div>
            </div>
        </div>
        <div class="card-body">
            <form @submit.prevent="saveSetting">
                <div class="form-row">
                    <div class="col-12">
                        <div class="text-danger"><strong>Important:</strong> Do not modify the [values] = [numdoc], [Organization Name], [amount].</div>
                        <div class="alert alert-info">
                            <strong>Message for Organization:</strong> Payment received successfully. <br />
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-check form-check-inline" style="width:200px;justify-content: flex-start;">
                            <label for="activeorgSMS" style="margin-right: 10px;"> Active for Org: </label>
                            <div class="onoffswitch">
                                <input type="checkbox" class="onoffswitch-checkbox" id="activeorgSMS"
                                    v-model="orgSMS" />
                                <label class="onoffswitch-label" for="activeorgSMS">
                                    <span class="onoffswitch-inner"></span>
                                    <span class="onoffswitch-switch"></span>
                                </label>
                            </div>
                        </div>
                        <div class="form-control box-message">
                            <label for="smsForOrg">Message:</label>
                            <textarea class="form-control" id="smsForOrg" v-model="smsForOrg" :disabled="!orgSMS"
                                placeholder="Message for Org" maxlength="140"></textarea>
                                <small>Max: {{smsForOrg.length}}/140</small>
                        </div>
                    </div>
                    <div class="col-12" style="display:none;">
                        <hr />
                    </div>
                    <div class="col-12" style="display:none;">
                        <div class="alert alert-info">
                            <strong>Message for Customer:</strong> Your payment has been received successfully. Thank you for your payment.
                        </div>
                    </div>
                    <div class="col-12" style="display:none;">
                        <div class="form-check form-check-inline" style="width:200px;justify-content: flex-start;">
                            <label for="activecustomerSMS" style="margin-right: 10px;"> Active for Customer: </label>
                            <div class="onoffswitch">
                                <input type="checkbox" class="onoffswitch-checkbox" id="activecustomerSMS"
                                    v-model="customerSMS" />
                                <label class="onoffswitch-label" for="activecustomerSMS">
                                    <span class="onoffswitch-inner"></span>
                                    <span class="onoffswitch-switch"></span>
                                </label>
                            </div>
                        </div>
                        <div class="form-control box-message">
                            <label for="smsForCustomer">Message:</label>
                            <textarea class="form-control" id="smsForCustomer" v-model="smsForCustomer" :disabled="!customerSMS"
                                placeholder="Message for Org" maxlength="140"></textarea>
                                <small>Max: {{smsForCustomer.length}}/140</small>
                        </div>
                    </div>
                    <div class="col-12">
                        <hr />
                        <button type="button" class="btn btn-light" @click="$parent.close()">CANCEL</button>
                        <button type="submit" class="btn btn-success" :disabled="isLoading">SAVE</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    name: 'NotiSmsPaymentReceived',
    components: {
    },
    data () {
        return {
            isLoading: false,
            title: '',
            smsForOrg: 'Payment received for invoice #[numdoc] from [Organization Name]. Amount: $[amount].',
            smsForCustomer: 'We have received your payment for invoice #[numdoc] from [Organization Name]. Amount: $[amount]. Thank you for your payment.',
            orgSMS: true,
            customerSMS: false,
            meta_key: 'smsPaymentReceived',
        };
    },
    created () {
        let t = this;
        let getModal = t.$store.getters['core/getOpenModal'];
        // t.title = getModal.data.title; // sin uso actualmente
        // t.meta_key = getModal.data.meta_key; // sin uso actualmente
        t.getStart();
    },
    methods: {
        getStart () {
            this.isLoading = true;
            this.$store.commit("core/setLoadingModal", true);
            window.billing
            .post('getKeyValSetting', {
                user_id: window.master_client,
                org_id: window.localorgdata,
                meta_key: this.meta_key,
            })
            .then((response) => {
                console.log(response.data);
                if(response.data.status){
                    if(response.data?.r!=null && response.data?.r!='' && response.data?.r?.meta_value!=null && response.data?.r?.meta_value.length>0){
                        let val = JSON.parse(response.data.r.meta_value);
                        if(val.smsForOrg != undefined && val.smsForOrg != null && val.smsForOrg != ''){
                            this.smsForOrg = val.smsForOrg;
                        }
                        if(val.smsForCustomer != undefined && val.smsForCustomer != null && val.smsForCustomer != ''){
                            this.smsForCustomer = val.smsForCustomer;
                        }
                        if(val.orgSMS != undefined && val.orgSMS != null && val.orgSMS != ''){
                            this.orgSMS = val.orgSMS;
                        }
                        if(val.customerSMS != undefined && val.customerSMS != null && val.customerSMS != ''){
                            this.customerSMS = val.customerSMS;
                        }
                    }
                }
                this.isLoading = false;
                this.$store.commit("core/setLoadingModal", false);
            })
            .catch((error) => {
                this.isLoading = false;
                this.$store.commit("core/setLoadingModal", false);
                console.log(error);
            });
        },
        saveSetting () {
            this.isLoading = true;
            this.$store.commit("core/setLoadingModal", true);
            let meta_value = {
                smsForOrg: this.smsForOrg,
                smsForCustomer: this.smsForCustomer,
                orgSMS: this.orgSMS,
                customerSMS: this.customerSMS,
            };
            window.billing
            .post('setAnyKeyValSetting', {
                user_id: window.master_client,
                org_id: window.localorgdata,
                meta_key: this.meta_key,
                meta_value: JSON.stringify(meta_value),
            })
            .then((response) => {
                this.isLoading = false;
                this.$store.commit("core/setLoadingModal", false);
                this.$store.commit("core/setCloseModal", {action: 'saved'});
            })
            .catch((error) => {
                this.isLoading = false;
                this.$store.commit("core/setLoadingModal", false);
                console.log(error)
            });
        },
    },
    computed: { },
};
</script>
<style lang="scss" scoped>
.onoffswitch-inner:before {
    padding-right: 0px;
    padding-left: 10px;
    background-color: #5ac146;
    color: #ffffff;
}
button.btn.btn-light {
    background: #fff;
    border: 1px solid #ddd;
    margin-right: 20px;
}
.box-message {
    position: relative;
    textarea {
        height: 100px;
        resize: none;
    }
    small {
        position: absolute;
        bottom: 0px;
        right: 0px;
        color: #888;
        background: #fff;
        border: 1px solid #ddd;
        padding: 2px 5px;
        line-height: 1;
        font-size: 12px;
        border-radius: 2px;
    }
}
</style>
